module.exports = __webpack_public_path__ + "static/media/3DPPA16.f370f7a0.jpg";